/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SiteNav_viewer$ref = any;
type TradeAccountManagerLink_viewer$ref = any;
type VipAccountManagerLink_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type BottomBar_viewer$ref: FragmentReference;
export type BottomBar_viewer = {|
  +$fragmentRefs: VipAccountManagerLink_viewer$ref & TradeAccountManagerLink_viewer$ref & SiteNav_viewer$ref,
  +$refType: BottomBar_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "BottomBar_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "VipAccountManagerLink_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "TradeAccountManagerLink_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SiteNav_viewer",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '04cd01779e71169bad88093006a4b657';
module.exports = node;
